<router-outlet />
<app-version />
